var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_23853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.07 231.682L12.8582 232.245H10L63.1631 254.547C82.218 254.252 124.926 253.34 143.765 253.34C148.338 253.34 148.91 253.581 151.768 253.581C154.055 253.581 156.913 253.286 158.056 253.098L220.366 251.552L194.07 231.682Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.07 91.6812L12.8582 95.6827H10L63.1631 254.029C82.218 251.933 124.926 245.454 143.765 245.454C148.338 245.454 148.91 247.169 151.768 247.169C154.055 247.169 156.913 245.073 158.056 243.739L220.366 240.881L194.07 91.6812Z",
    fill: "#CDCDCD",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0259 242.024L69.4512 249.455C90.7926 247.169 136.334 242.252 147.767 240.881C159.2 239.509 193.308 239.166 208.933 238.594L218.651 228.876C200.739 230.019 162.744 232.992 154.055 235.736C143.079 228.876 98.7957 237.07 78.0259 242.024Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.51 231.735C208.248 229.448 171.396 235.355 154.628 238.594L145.481 204.867L208.934 198.007C210.077 201.628 214.193 213.442 221.51 231.735Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8613 93.9676C38.1235 89.3944 59.3507 91.2999 68.3064 92.8243C84.5031 112.832 123.985 169.654 152.338 236.879C143.649 231.849 98.4131 238.975 76.8811 243.167C64.686 207.535 37.2089 127.809 24.8613 93.9676Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.8 224.303C216.708 223.388 173.682 233.83 154.056 239.166L122.615 136.269L203.789 135.126C206.838 146.368 216.708 179.943 231.8 224.303Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0825 101.153C47.8991 100.953 67.5671 102.001 75.7063 107.788",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8999 108.985C50.7165 108.785 70.3845 109.832 78.5237 115.619",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4634 118.188C53.2499 117.318 72.9776 116.878 81.5962 122.079",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6562 126.271C56.4428 125.401 76.1705 124.961 84.7891 130.162",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4741 134.102C59.2606 133.232 78.9883 132.792 87.607 137.993",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4336 141.856C63.2201 140.986 82.9478 140.546 91.5664 145.747",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2539 149.688C66.0404 148.818 85.7681 148.378 94.3868 153.579",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2891 158.583C70.0756 157.713 89.8033 157.273 98.4219 162.474",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0322 165.273C72.8187 164.403 92.5464 163.963 101.165 169.164",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7251 174.341C75.44 172.882 95.1176 171.122 104.109 175.759",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.666 182.484C79.3502 180.842 98.9931 178.673 108.091 183.127",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9707 192.364C83.2714 190.533 102.114 187.934 111.079 192.184",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0903 199.45C88.2235 197.947 106.642 196.087 115.252 200.672",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9907 206.709C90.3901 205.139 109.4 203.13 118.246 207.651",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7163 214.916C94.1157 213.346 113.126 211.336 121.971 215.858",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6763 222.67C98.0756 221.1 117.086 219.091 125.931 223.612",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8706 82.5344C67.1633 79.7905 92.3157 87.8698 102.605 92.2524C118.421 129.219 150.967 210.126 154.625 238.022C147.308 230.705 115.753 231.544 100.89 232.877C90.2197 202.771 64.8767 130.553 48.8706 82.5344Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.054 235.736L104.893 96.8261C116.783 90.4236 170.06 83.8687 195.213 81.3916C195.784 81.7727 206.76 109.288 246.089 216.3C235.114 214.014 180.159 228.305 154.054 235.736Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.479 105.048C130.324 100.963 162.306 93.1817 187.462 94.7308",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.48 112.077C135.326 107.993 167.307 100.211 192.464 101.76",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.582 128.15C138.427 124.065 170.409 116.284 195.566 117.833",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.013 135.101C142.859 131.017 174.84 123.235 199.997 124.784",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.135 143.15C144.981 139.066 176.962 131.284 202.119 132.833",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.994 150.008C144.84 145.924 176.821 138.143 201.978 139.692",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.238 159.222C148.084 155.138 180.065 147.356 205.222 148.906",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.55 165.008C151.396 160.923 183.377 153.142 208.534 154.691",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.837 171.936C154.683 167.852 186.664 160.07 211.821 161.619",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.389 180.055C160.235 175.971 192.216 168.189 217.373 169.738",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.679 186.984C163.525 182.899 195.506 175.118 220.663 176.667",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.49 196.128C163.336 192.043 195.317 184.262 220.474 185.811",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.924 203.08C167.77 198.995 199.751 191.214 224.908 192.763",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.188 211.151C171.034 207.067 203.015 199.285 228.172 200.834",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.619 218.103C175.465 214.019 207.446 206.237 232.603 207.787",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.339 119.082C139.185 114.998 171.166 107.216 196.323 108.765",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5762 100.828L25.4359 93.968L78.0274 242.596L70.0243 249.456L18.5762 100.828Z",
    fill: "#F2F2F2",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.647 89.1279C66.4476 89.229 86.0474 90.9782 94.0423 97.1663",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.248 97.033C69.0486 97.134 88.6485 98.8832 96.6434 105.071",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5566 106.33C71.3466 105.752 91.0494 105.994 99.5415 111.586",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5244 114.497C74.3143 113.919 94.0172 114.162 102.509 119.753",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1304 122.403C76.9203 121.826 96.6231 122.068 105.115 127.66",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.875 130.262C80.6649 129.685 100.368 129.927 108.86 135.519",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.481 138.168C83.2709 137.591 102.974 137.833 111.466 143.425",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.27 147.17C87.0599 146.593 106.763 146.835 115.255 152.427",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8306 153.934C89.6205 153.356 109.323 153.599 117.815 159.191",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.271 163.09C92.006 161.916 111.696 160.823 120.578 165.845",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9883 171.341C95.6978 169.983 115.365 168.476 124.358 173.314",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0186 181.345C99.3502 179.784 118.23 177.818 127.096 182.441",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9443 188.564C104.099 187.328 122.535 186.093 131.036 191.045",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.645 195.871C106.068 194.575 125.099 193.209 133.838 198.106",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.145 204.176C109.568 202.88 128.599 201.514 137.338 206.411",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.889 212.035C113.312 210.74 132.342 209.373 141.081 214.27",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4468 80.8198C94.0321 79.9052 104.322 91.1095 104.893 96.8259C115.945 127.504 141.25 198.122 154.055 235.164C149.482 227.847 121.662 228.686 108.323 230.02C106.227 223.731 93.1175 185.088 57.4468 80.8198Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3081 88.251C77.0734 88.8226 96.5474 91.6809 104.322 98.5406",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5938 96.2537C79.359 96.8253 98.8331 99.6835 106.607 106.543",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5273 105.709C81.3103 105.58 100.95 106.876 109.247 113.094",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1689 113.989C83.9519 113.859 103.592 115.156 111.889 121.373",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5986 121.992C87.3815 121.863 107.022 123.159 115.318 129.377",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8843 129.995C89.6672 129.866 109.307 131.162 117.604 137.38",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.313 137.998C93.0959 137.868 112.736 139.165 121.033 145.382",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7451 147.144C96.528 147.015 116.168 148.311 124.465 154.529",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0312 154.004C98.8142 153.875 118.454 155.171 126.751 161.389",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.106 163.295C100.859 162.554 120.541 162.48 129.251 168.105",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3438 171.698C103.078 170.769 122.755 170.271 131.583 175.707",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1167 181.876C107.482 180.723 126.391 179.717 135.102 184.915",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.75 189.274C111.926 188.442 130.361 188.158 138.694 193.68",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.159 196.638C113.605 195.759 132.64 195.372 141.212 200.852",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.179 205.076C115.625 204.197 134.659 203.81 143.232 209.29",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.611 213.079C119.057 212.2 138.092 211.812 146.664 217.293",
    stroke: "#F2F2F2",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.468556,
    y1: -0.468556,
    x2: 8.70251,
    y2: -0.468556,
    transform: "matrix(-0.779055 -0.679182 -0.640005 0.721083 42.5908 76.5337)",
    stroke: "#222222",
    strokeWidth: 0.937112,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.468556,
    y1: -0.468556,
    x2: 5.37467,
    y2: -0.468556,
    transform: "matrix(0.069129 1.00993 -0.985092 0.0268851 48.4072 68.6733)",
    stroke: "#222222",
    strokeWidth: 0.937112,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.468556,
    y1: -0.468556,
    x2: 5.13556,
    y2: -0.468556,
    transform: "matrix(0.987876 0.007746 0.208623 1.0001 35.312 81.5549)",
    stroke: "#222222",
    strokeWidth: 0.937112,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.389 181.121C170.26 178.323 197.43 168.825 201.276 141.918C202.762 131.526 187.858 124.134 179.608 130.321C171.358 136.508 177.846 162.343 200.12 150.005C222.395 137.666 228.246 116.171 228.747 112.667",
    stroke: "#222222",
    strokeWidth: 0.604167
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.497 72.3482L285.488 69.1037L230.995 82.3354L204.497 72.3482Z",
    fill: "#D7F1FA",
    stroke: "#222222",
    strokeWidth: 0.604167
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.799 107.468L228.823 82.582L284.76 68.8625L236.799 107.468Z",
    fill: "#C7ECF9",
    stroke: "#222222",
    strokeWidth: 0.604167
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.597 100.622L284.434 67.9044L251.116 88.8737L281.597 100.622Z",
    fill: "#D7F1FA",
    stroke: "#222222",
    strokeWidth: 0.604167
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_23853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentation);
export default __webpack_public_path__ + "static/media/documentation.c4d851e242ae6d1e238abef7ef41071d.svg";
export { ForwardRef as ReactComponent };